var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.imgarr),function(imgurl,index){return _c('div',{key:index,staticClass:"imglist"},[_c('img',{attrs:{"src":imgurl,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }